import Vue from 'vue'
import Notifications from 'vue-notification'
Vue.use(Notifications);

export function DisplayMessage(title, message, type){
    Vue.notify({
        group: 'app',
        title: title,
        text: message,
        position: ['top', 'left'],
        type: type,
        duration: 2000,
        speed: 500
    })
};

export function DisplayError(title, message){
    DisplayMessage(title, message, toastTypes.error);
};

export function DisplaySuccess(title, message){
    DisplayMessage(title, message, toastTypes.success);
};

export function DisplayWarning(title, message){
    DisplayMessage(title, message, toastTypes.warn);
};

export function DisplayInfo(title, message){
    DisplayMessage(title, message, toastTypes.info);
};

const toastTypes = {
    success: 'success',
    error: 'error',
    info: 'info',
    warn: 'warn'
}